import studiesGetters from './getterTypes'

const getters = {
  [studiesGetters.GET_SAVED_SEARCHES]: state => state.savedSearches,
  [studiesGetters.GET_QUESTIONS]: state => state.studyMapping,
  [studiesGetters.GET_FIELDS]: state => state.fields,
  [studiesGetters.GET_SEARCH_FILTERS]: state => state.filterValues,
  [studiesGetters.GET_CICS_FILTERS]: state => state.cicsFilterValues,
  [studiesGetters.GET_CICS_QUESTIONS]: state => state.cics,
  [studiesGetters.GET_STUDY_SUMMARIES]: state => state.summaries,
  [studiesGetters.GET_ANALYTICS]: state => state.analytics.metrics,
  [studiesGetters.GET_ANALYTICS_PROFILE]: state => state.analytics.performance,
  [studiesGetters.GET_ANALYTICS_ATTRIBUTES]: state => state.analytics.attributes,
  [studiesGetters.GET_ANALYTICS_TENDENCIES]: state => state.analytics.tendencies,
  [studiesGetters.GET_METRICS_JOB_ID]: state => state.analyticsJobIds.metrics,
  [studiesGetters.GET_PERFORMANCE_JOB_ID]: state => state.analyticsJobIds.performance,
  [studiesGetters.GET_ATTRIBUTES_JOB_ID]: state => state.analyticsJobIds.attributes,
  [studiesGetters.GET_TENDENCIES_JOB_ID]: state => state.analyticsJobIds.tendencies,
  [studiesGetters.GET_METRICS_XLSX_JOB_ID]: state => state.analyticsJobIds.metricsXLSX,
  [studiesGetters.GET_METRICS_ANALYTIC_JOB_ID]: state => state.analyticsJobIds.metricsAnalytic,
  [studiesGetters.GET_PERFORMANCE_XLSX_JOB_ID]: state => state.analyticsJobIds.performanceXLSX,
  [studiesGetters.GET_ATTRIBUTES_XLSX_JOB_ID]: state => state.analyticsJobIds.attributesXLSX,
  [studiesGetters.GET_TENDENCIES_XLSX_JOB_ID]: state => state.analyticsJobIds.tendenciesXLSX,
  [studiesGetters.GET_FRAGRANCES]: state => state.fragrances,
  [studiesGetters.GET_CONCEPTS]: state => state.concepts,
  [studiesGetters.GET_QUESTIONNAIRES]: state => state.files.questionnaire,
  [studiesGetters.GET_SCREENERS]: state => state.files.screener,
  [studiesGetters.GET_REPORTS]: state => state.files.report,
  [studiesGetters.GET_RESULTS]: state => state.files.RDF,
  [studiesGetters.GET_PROTOCOLS]: state => state.files.protocol,
  [studiesGetters.GET_STUDY_DETAILS_METADATA]: state => state.studyDetails.metadata,
  [studiesGetters.GET_STUDY_DETAILS_TAGS]: state => state.studyDetails.tags.study_details,
  [studiesGetters.GET_CONCEPTS_TAGS]: state => state.studyDetails.tags.concepts,
  [studiesGetters.GET_FRAGRANCES_TAGS]: state => state.studyDetails.tags.fragrances,
  [studiesGetters.GET_STUDY_ERROR]: state => state.studyError,
  [studiesGetters.GET_STUDY_DETAILS_FRAGRANCE_DETAILS]: state => state.studyDetails.fragrance_details,
  [studiesGetters.GET_STUDY_DETAILS_CONCEPTS]: state => state.studyDetails.concepts,
  [studiesGetters.GET_STUDY_COUNT]: state => state.studyCount,
  [studiesGetters.GET_SIGNIFICANCE_RESULTS]: state => state.significance.results,
  [studiesGetters.GET_SIGNIFICANCE_JOB_ID]: state => state.analyticsJobIds.significance
}

export default {
  ...getters
}
